import React from "react";
import ReactDom from "react-dom";

const useCreatePortal = typeof ReactDom.createPortal === "function";
export const isBrowser = typeof window !== "undefined";

class Portal extends React.Component {
	constructor(props) {
		super(props);

		if (isBrowser) {
			this.container = document.createElement("div");
			this.container.className = "hidden";
			document.body.appendChild(this.container);

			this.renderLayer();
		}
	}

	componentDidUpdate() {
		this.renderLayer();
	}

	componentWillUnmount() {
		if (!useCreatePortal) {
			ReactDom.unmountComponentAtNode(this.container);
		}

		document.body.removeChild(this.container);
	}

	renderLayer() {
		if (!useCreatePortal) {
			ReactDom.unstable_renderSubtreeIntoContainer(this, this.props.children, this.container);
		}
	}

	render() {
		if (useCreatePortal) {
			this.container.className = "block";
			return ReactDom.createPortal(this.props.children, this.container);
		}
		return null;
	}
}

export default Portal;
